import { Info } from '@phosphor-icons/react';

export default Info;
